import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./Firebase";
import firebase from "firebase/app";

export default function Login() {

    const navi = useNavigate();

    useEffect(() => {
        if (window.particlesJS) {
            window.particlesJS("particles-js", {
                particles: {
                    number: { value: 80, density: { enable: true, value_area: 600 } },
                    color: { value: "#FFFFFF" },
                    shape: { type: "circle" },
                    opacity: { value: 0.8 },
                    size: { value: 4 },
                    line_linked: { enable: true, distance: 150, color: "#FFFFFF", opacity: 0.4, width: 1 },
                    move: { enable: true, speed: 2, direction: "none", out_mode: "out" }
                },
                interactivity: {
                    detect_on: "canvas",
                    events: {
                        onhover: { enable: true, mode: "repulse" },
                        onclick: { enable: true, mode: "push" },
                        resize: true
                    },
                    modes: {
                        repulse: { distance: 100, duration: 0.4 },
                        push: { particles_nb: 4 }
                    }
                },
                retina_detect: true
            });
        }
    }, []);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                navi("/Dashboard");
            }
        });
        return () => unsubscribe();
    }, [navi]);

    function loginForm(e) {
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        const email = data.get("email").trim().toLowerCase();
        const password = data.get("password").trim();

        auth.signInWithEmailAndPassword(email, password)
            .then((userCredential) => {
                const user = userCredential.user;

                // Update last login in Firestore
                db.collection("users")
                    .doc(user.uid)
                    .update({
                        lastLogin: firebase.firestore.FieldValue.serverTimestamp()
                    })
                    .catch(err => console.error("Error updating last login:", err));

                navi("/Dashboard");
            })
            .catch(() => {
                alert("Wrong Email or Password");
            });
    }

    const [log, setlog] = useState("");

    function checklogin() {
        auth.onAuthStateChanged((user) => {
            if (user) {
                var uid = user.uid;
                setlog(uid)
            } else {
                setlog("")
            }
        })
    }

    useEffect(() => {
        checklogin();
    }, [])


    return (
        <div className="row m-0 justify-content-center align-items-center vh-100 backgrounddd">
            <div id="particles-js"></div>
            <div className="col-lg-4 card glass p-3 content-container">
                <form className="text-center" onSubmit={loginForm}>
                    <div className="card-body p-4">
                        <h4 className="text-light mb-3">Sign in with email</h4>
                        <input type="email" placeholder="Fill your Email" name="email" className="bg-light form-control mb-2" required />
                        <input type="password" placeholder="Fill your Password" name="password" className="bg-light form-control mb-2" required />
                        <button type="submit" className="form-control w-75 m-auto text-light fw-bold mt-4" style={{ backgroundColor: "#F5891D" }}>Submit</button>
                        <div className="d-flex align-items-center justify-content-center mt-2">
                            {/* <a><p className="text-center text-light">Forgot Password?</p></a> */}
                        </div>
                    </div>
                </form>
            </div>

            <marquee direction="right" className="bg-light py-3 w-100 position-absolute bottom-0">
                <h5 className="text-primary fw-bold" style={{ fontFamily: "cursive" }}>
                    Welcome To Hack98Denims: Elevate Your Wardrobe with Hack98Denim Finest Men's Fashion..
                </h5>
            </marquee>
        </div>
    );
}
